module.exports = __webpack_public_path__ + "static/media/public.a3378c83.svg";